import { createContext, useEffect, useState } from "react";

export const NavigationContext = createContext();

const NavigationProvider = ({ children, pathname }) => {
  const [activePage, setActivePage] = useState("/");

  useEffect(() => {
    setActivePage(pathname);
  }, [pathname]);

  return (
    <NavigationContext.Provider value={{ activePage: activePage }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
